import { SelectOption } from '@/components/form-components/MultiSelectCombobox'
import { RestSchemas } from '@/contexts/QueryProvider'

export type DataAssetSummaryRow = RestSchemas['Messages.DataAssets.TDataAssetActivity']

export type WorkspaceDataAssetsFilterOptions = {
  entityTypeOptions: SelectOption<string>[]
  dataAssetOptions: SelectOption<string>[]
  entityNameOptions: SelectOption<string>[]
}

export const normalizeValue = (value?: string | null) => value?.trim() ?? ''

export const getEntityTypeName = (row: DataAssetSummaryRow) =>
  normalizeValue(row.entity?.entity_type?.name) || normalizeValue(row.data_asset?.entity_type?.name)

export const getDataAssetName = (row: DataAssetSummaryRow) => normalizeValue(row.data_asset?.name)

export const getEntityName = (row: DataAssetSummaryRow) => normalizeValue(row.entity?.name)

export const getFileName = (row: DataAssetSummaryRow) =>
  normalizeValue(row.file_name) || normalizeValue(row.data_asset?.file_name)

export const getFileUrl = (row: DataAssetSummaryRow) => normalizeValue(row.url)

export const getDateValue = (row: DataAssetSummaryRow) => normalizeValue(row.date)

export const getStateValue = (row: DataAssetSummaryRow) => normalizeValue(row.state)

const buildSelectOptions = (values: string[]): SelectOption<string>[] =>
  Array.from(new Set(values.filter(Boolean)))
    .sort((a, b) => a.localeCompare(b))
    .map((value) => ({ value, label: value }))

export function getWorkspaceDataAssetsFilterOptions(
  summary: DataAssetSummaryRow[]
): WorkspaceDataAssetsFilterOptions {
  return {
    entityTypeOptions: buildSelectOptions(summary.map(getEntityTypeName)),
    dataAssetOptions: buildSelectOptions(summary.map(getDataAssetName)),
    entityNameOptions: buildSelectOptions(summary.map(getEntityName)),
  }
}
